import Button from "../components/button";
import FormHead from "../components/headings/FromHead";
import Styles from "./styles.module.scss";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { DropDownInput } from "../wrappers/selectInput";
import * as CONSTANTS from '../utils/CONSTANTS'
import { useEffect, useState , useMemo } from "react";


export type LanguageFormFields = {
  name: string;
  proficiency: string;
  action: string;
  languageId?: string
};

interface Props {
  ClickHandler :any;
  onClose:any;
  defaultLanguages:any;
  defaultValues: any
}
const validationSchema = Yup.object({
    name: Yup.string()
    .required('Field is required'),
    proficiency: Yup.string()
    .required('Field is required')
})


  const LanguageForm: React.FC<Props> = ({
    ClickHandler,
    onClose,
    defaultLanguages,
    defaultValues
  }) => { 
 
    const formOptions = {
      resolver:yupResolver(validationSchema), defaultValues: useMemo(() => {
        return defaultValues;
      }, [defaultValues])
    }
     
    const {
      register,
      handleSubmit,
      control,
      reset,
      setValue,
      formState: { errors },
    } = useForm<LanguageFormFields>(formOptions);
  
    const [languages ] = useState(CONSTANTS.LANGUAGES)
    const [disable, setDisable] = useState(false);
    
    useEffect(() => {

      if(defaultValues){     
          reset(defaultValues);
          setValue('action', 'update')
      }else {
        setValue('action', 'add')
      }

    }, [defaultValues, reset, setValue]);

    const onSubmit = (data:any) => {
      setDisable(true)
      ClickHandler(data)
    }
    
    return(
      <div className={Styles.detailsCard}>
            <FormHead>Language Proficiency</FormHead>
            <div className="half-form-wrap mb-0">
            <DropDownInput<LanguageFormFields>
                    name="name"
                    label="Language*"
                    data={languages.filter( (e) => !defaultLanguages.includes(e) )}
                    register={register}
                    errors={errors}
                    control={control}
                  />
                <DropDownInput<LanguageFormFields>
                    name="proficiency"
                    label="Proficiency*"
                    data={CONSTANTS.languageProficiency}
                    register={register}
                    errors={errors}
                    control={control}
                  />
              </div>
              <div className={Styles.popupAction}>
              <Button onClick={onClose} type="submit" variant="secondary" size="small">Cancel</Button>
              <Button  disabled={disable} onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="small">Save</Button>
            </div>
        </div>
    )
}

export default LanguageForm;